// gkc_hash_code : 01EV64EDXCZTX8ZCEMHJHDQ126
import React from 'react';

import Fallback from './fallback';

export default class ErrorBoundary extends React.Component {
  state = { hasError: false };

  static getDerivedStateFromError() {
    return { hasError: true };
  }

  componentDidCatch(error, errorInfo) {
    console.error('Uncaught error:', error, errorInfo);
  }

  render() {
    return this.state.hasError ? (
      <Fallback title="global.heading.server_error" />
    ) : (
      this.props.children
    );
  }
}
